var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEditorCoord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55556 2.77778C5.55556 4.3119 4.3119 5.55556 2.77778 5.55556C1.24365 5.55556 0 4.3119 0 2.77778C0 1.24365 1.24365 0 2.77778 0C4.3119 0 5.55556 1.24365 5.55556 2.77778Z",
    fill: "#334D6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 2.77778C19.9999 4.3119 18.7562 5.55556 17.2221 5.55556C15.688 5.55556 14.4443 4.3119 14.4443 2.77778C14.4443 1.24365 15.688 0 17.2221 0C18.7562 0 19.9999 1.24365 19.9999 2.77778Z",
    fill: "#334D6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55556 17.2221C5.55556 18.7562 4.3119 19.9999 2.77778 19.9999C1.24365 19.9999 0 18.7562 0 17.2221C0 15.688 1.24365 14.4443 2.77778 14.4443C4.3119 14.4443 5.55556 15.688 5.55556 17.2221Z",
    fill: "#334D6E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 17.2221C19.9999 18.7562 18.7562 19.9999 17.2221 19.9999C15.688 19.9999 14.4443 18.7562 14.4443 17.2221C14.4443 15.688 15.688 14.4443 17.2221 14.4443C18.7562 14.4443 19.9999 15.688 19.9999 17.2221Z",
    fill: "#334D6E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8891 3.11108H4.11133C3.55904 3.11108 3.11133 3.5588 3.11133 4.11108V15.8889C3.11133 16.4411 3.55904 16.8889 4.11133 16.8889H15.8891C16.4414 16.8889 16.8891 16.4411 16.8891 15.8889V4.11108C16.8891 3.5588 16.4414 3.11108 15.8891 3.11108ZM4.11133 1.11108C2.45447 1.11108 1.11133 2.45423 1.11133 4.11108V15.8889C1.11133 17.5457 2.45447 18.8889 4.11133 18.8889H15.8891C17.546 18.8889 18.8891 17.5457 18.8891 15.8889V4.11108C18.8891 2.45423 17.546 1.11108 15.8891 1.11108H4.11133Z",
    fill: "#334D6E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditorCoord);
export default __webpack_public_path__ + "static/media/icon-editor-coord.f724c9c6f67897510d9a7b7c9467603e.svg";
export { ForwardRef as ReactComponent };